import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import FoodDrinkApi from "api/foodDrinkApi";
import { formatQueryParams } from "helpers/format";


export const getFoodDrinkApi = async (params: any = {}) => {
  try {
    const response = await FoodDrinkApi.foodDrink(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
}

export const getFoodDrinks = createAsyncThunk("FoodDrinks", getFoodDrinkApi);
export const getWallpapers = createAsyncThunk("Wallpaper", getFoodDrinkApi)